import type { TupleToUnion } from 'type-fest'

export type ProjectPageTab = 'details' | 'activity' | 'finance' | 'internal'

export type DashboardPageTab =
  | 'all'
  | 'draft'
  | 'submitted'
  | 'in-progress'
  | 'my-projects'
  | 'completed'
  | 'archived'
  | 'rejected'
  | 'opportunities'
  | 'dismissed'
  | 'closed'

// The order in which these are listed are the order in which they appear in the tab group
export const accountPageTabs = [
  'profile',
  'organization',
  'organizations',
  'team',
  'teams',
  'users',
  'billing',
  'payments',
] as const
export type AccountPageTab = TupleToUnion<typeof accountPageTabs>
